export const USER = 'user'

const ROUTER = {
  DEFAULT: '/',
  HOME: '/',
  SVG_VIEWER: '/svg-viewer',
  DESIGN_SYSTEM: '/design-system',

  // ADMIN
  QUAN_LY_PHAN_QUYEN: '/phan-quyen',
  QUAN_LY_NGUOI_DUNG: '/quan-ly-nguoi-dung',
  THAM_SO_HE_THONG: '/tham-so-he-thong',

  // VBDT
  LOGIN: '/dang-nhap',
  DANG_NHAP_OTP: '/dang-nhap-otp',

  DAT_MAT_KHAU: '/dat-mat-khau',
  CHU_VAN_BANG_THIEU_LIEN_HE: '/chu-van-bang-thieu-lien-he',
  TAI_KHOAN_DAI_DIEN: '/tai-khoan-dai-dien',
  TAI_KHOAN_CONG_DAN: '/tai-khoan-cong-dan',
  HANG_CHO_KY: '/hang-cho-ky',
  THONG_KE_KY: '/thong-ke-ky',
  VAN_BANG: '/van-bang',
  QUAN_LY_HO_SO: '/ho-so',
  HO_SO_CHI_TIET: '/ho-so/:id',
  HO_SO_PHAT_HANH: '/ho-so/:id/phat-hanh',
  KHO_VAN_BANG: '/van-bang',
  GUI_VAN_BAN: '/gui-van-ban',
  TRA_CUU: '/tra-cuu',
  NHAT_KY_HE_THONG: '/nhat-ky-he-thong',
  LOAI_VAN_BANG: '/loai-van-bang',
  LOAI_VAN_BANG_CHI_TIET: '/loai-van-bang/:id',
  GIAM_SAT_VAN_HANH: '/giam-sat-van-hanh',
  OUTBOX_MONITOR: '/theo-doi-tac-vu-nen',
  BAO_CAO: '/bao-cao',
  BANG_DIEU_KHIEN: '/bang-dieu-khien',
  LOAI_HO_SO: '/loai-ho-so',
  LOAI_HO_SO_CAU_HINH: '/loai-ho-so/:id/cau-hinh',
  CAU_HINH_VUNG_KY: '/cau-hinh-vung-ky',
  DUYET_CHU_KY: '/duyet-chu-ky',
  LUONG_KY: '/luong-ky',
  CHUC_VU: '/chuc-vu',
  QUAN_LY_THONG_BAO: '/quan-ly-thong-bao',
  TRANG_CHU_QUAN_TRI: '/trang-chu-quan-tri',
  IMPORT_TAI_LIEU: '/import-tai-lieu',
  CA_TIN_CAY: '/ca-tin-cay',

  // USER
  CHU_KY_CUA_TOI: '/chu-ky-cua-toi',
  VAN_BAN_DA_KY: '/van-ban-da-ky',
  HO_SO_DA_KY: '/van-ban-da-ky',
  MY_DOSSIERS: '/van-bang-cua-toi',
  MY_DOSSIER_CHI_TIET: '/van-bang-cua-toi/:id',
}

export default ROUTER
